<div [innerHTML]="content"></div>